import axios from "axios";
import { Logger } from "@base-provider";

export const createIdea = (apiKey, projectCode, idea) => {
  Logger.of("App.Core.AHA.services.createIdea").info({
    apiKey,
    projectCode,
    idea,
  });
  return axios.request({
    method: "POST",
    baseURL: "https://eycs.aha.io",
    url: `/api/v1/products/${projectCode}/ideas`,
    data: {
      idea,
    },
    responseType: "application/json",
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
  });
};

export const createAttachment = (
  apiKey,
  projectCode,
  { note_id, screenshot }
) => {
  Logger.of("App.Core.AHA.services.createAttachment").info({
    note_id,
    screenshot,
  });
  const form = new FormData();

  form.append("attachment[data]", screenshot, "screenshot.png");

  return axios.request({
    method: "POST",
    baseURL: "https://eycs.aha.io",
    url: `/api/v1/notes/${note_id}/attachments`,
    data: form,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${apiKey}`,
    },
  });
};

export const getCategories = (apiKey, projectCode) => {
  return axios.request({
    method: "GET",
    baseURL: "https://eycs.aha.io",
    url: `/api/v1/products/${projectCode}/idea_categories`,
    responseType: "application/json",
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
  });
};

export const getInitiatives = (apiKey, projectCode) => {
  return axios.request({
    method: "GET",
    baseURL: "https://eycs.aha.io",
    url: `/api/v1/products/${projectCode}/initiatives`,
    responseType: "application/json",
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
  });
};
